<template>
  <div>
    <report-conversation :type="'comment'"></report-conversation>
  </div>
</template>

<script>
import ReportConversation from './report/ReportConversation'
export default {
  components: {
    ReportConversation
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/Comment.vue